module.exports = __webpack_public_path__ + "static/icon_buyStep1-6b5f7a968d07790b064bbde0b1a8be5f.png";